// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__1_17j","selected":"Chip_selected__ZhGWr"};